"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEARTBEAT_EVENTS = exports.HEARTBEAT_INTERVAL = void 0;
var time_1 = require("@walletconnect/time");
exports.HEARTBEAT_INTERVAL = time_1.FIVE_SECONDS;
exports.HEARTBEAT_EVENTS = {
  pulse: "heartbeat_pulse"
};